import _ from 'lodash';
import { connect } from 'react-redux';
import { search, remove } from '../../modules/apAutomation/apIngestionResult';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = (state) => {
	let apIngestionResults;
	if (state.lists.apIngestionResultIds) {
		apIngestionResults = _.map(
			state.lists.apIngestionResultIds,
			(id) => state.maps.apIngestionResult[id]
		);
	}

	return {
		apIngestionResults,
		authUser: state.auth.authUser,
		userMap: state.maps.user,
		resourceMap: state.maps.resource,
		apIngestionDocumentMap: state.maps.apIngestionDocument,

		carrierMap: state.maps.carrier,
		supplierMap: state.maps.supplier,
		terminalMap: state.maps.terminal,
		stationMap: state.maps.station,
		stationInvoiceMap: state.maps.stationInvoice,
		stationDeliveryMap: state.maps.stationDelivery,
	};
};
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			apIngestionResultSearch: search,
			apIngestionResultRemove: remove,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
